import { FormsConstants } from '@evorait/pace-forms';
import { updateServiceActivityType } from '../actions/form.actions';
import { Action, createReducer, on } from '@ngrx/store';
import { initialServiceActivityState, ServiceActivityState } from '../state/service-activity.state';

export function updateServiceActivityTypeReducer(
    state: Readonly<ServiceActivityState>,
    props: { serviceActivity: FormsConstants.SERVICE_ACTIVITY_TYPES },
): Readonly<ServiceActivityState> {
    return props.serviceActivity ?? state;
}

export const createServiceActivityReducer = createReducer(
    initialServiceActivityState,
    on(updateServiceActivityType, updateServiceActivityTypeReducer),
);

export function serviceActivityReducer(
    state: Readonly<ServiceActivityState>,
    action: Action,
): Readonly<ServiceActivityState> {
    return createServiceActivityReducer(state, action);
}
